// extracted by mini-css-extract-plugin
export default {"planStop":"planStop_planStop__0IVyt","title":"planStop_title__bxnC9","sub":"planStop_sub__Zlbl3","active":"planStop_active__ZkZll","warning":"planStop_warning__HptlC"};